import { LocationDescriptorObject } from 'history'
import { Action } from 'redux'

type NavigateConfig = LocationDescriptorObject

export const NAVIGATE = '[core] Router Navigate'
export const REDIRECT = '[core] Router Redirect'
export const RELOAD = '[core] Router Reload Page'

export class NavigateAction implements Action {
  readonly type = NAVIGATE
  constructor(public payload: NavigateConfig) {}
}

export class RedirectAction implements Action {
  readonly type = REDIRECT
  constructor(public payload: NavigateConfig) {}
}

export class ReloadAction implements Action {
  readonly type = RELOAD
}

type RouterActions = NavigateAction | RedirectAction | ReloadAction

export default RouterActions



// WEBPACK FOOTER //
// ./src/app/core/store/router.actions.ts